import { createContext, useContext, useState, type ReactNode } from 'react';
import { ErrorModal } from '@/components/ui/ErrorModal';

interface NotificationContextType {
    showNotification: (title: string, message: string, type?: 'error' | 'success' | 'info') => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
    const [open, setOpen] = useState(false);
    const [content, setContent] = useState({ title: '', message: '', type: 'error' as 'error' | 'success' | 'info' });

    const showNotification = (title: string, message: string, type: 'error' | 'success' | 'info' = 'error') => {
        setContent({ title, message, type });
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            <ErrorModal
                open={open}
                onClose={handleClose}
                title={content.title}
                message={content.message}
                type={content.type}
            />
        </NotificationContext.Provider>
    );
};

export const useNotify = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotify must be used within a NotificationProvider');
    }
    return context;
};
